// extracted by mini-css-extract-plugin
export default {"content":"ContactItem_content__mZutA","content__img":"ContactItem_content__img__lpO8x","content__info":"ContactItem_content__info__pwgNW"};